export const normalizePartnerId = (value?: string | null): string => value?.trim() ?? ''
